export const APPOINTMENT_DATE = 'appointment_date',
  AVAILABILITY_DATES = 'availability_dates',
  BRAND_INVOICE_ADDRESS = 'brand_invoice_address',
  BRAND_INVOICE_CONTACT = 'brand_invoice_contact',
  CANCELLATION_DOCUMENTATION = 'cancellation_documentation',
  JOB_MEDIA_FILES = 'job_media_files',
  CUSTOMER_DETAILS = 'customer_details',
  CUSTOMER_2_DETAILS = 'customer_2_details',
  FORM_ANSWERS = 'form_answers',
  CUSTOMER_EID = 'customer_eid',
  CUSTOMER_INVOICE_ADDRESS = 'customer_invoice_address',
  CUSTOMER_INVOICE_CONTACT = 'customer_invoice_contact',
  DELIVERY_DATE = 'delivery_date',
  DOCUMENTATION = 'documentation',
  DOCUMENTATION_PICTURE = 'documentation_picture',
  FINISHED_TIMESTAMP = 'finished_timestamp',
  INTERNAL_COMMENTS = 'internal_comments',
  INVOICES_STATUS = 'invoices_status',
  JOB_SEQUENCE = 'job_sequence',
  ORDER_EID = 'order_eid',
  INVOICING_EID = 'invoicing_eid',
  PARTNER_EID = 'partner_eid',
  PROJECT_ID = 'project_id',
  ORDER_AFFILIATE_ID = 'affiliate_id',
  PARTNER_ASSIGNED = 'partner_assigned',
  PARTNER_INVOICE_ADDRESS = 'partner_invoice_address',
  PARTNER_INVOICE_CONTACT = 'partner_invoice_contact',
  PLANNING_CUSTOMER = 'planning_customer',
  PLANNING_PARTNER = 'planning_partner',
  PRODUCTS = 'products',
  PROFESSIONAL_COMMENT = 'professional_comment',
  PROPERTIES = 'properties',
  READINESS_DATE = 'readiness_date',
  SERVICES = 'services',
  ADDITIONAL_ITEMS = 'additional_items',
  START_TIMESTAMP = 'start_timestamp',
  TAX_PROFILE = 'tax_profile',
  BRAND_2 = 'brand_2',
  WALLBOX_PRIORITIES = 'wallbox_priorities',
  TICKETS_LIST = 'tickets_list',
  DETAILS = 'details',
  OWN_INSTALLER = 'own_installer',
  CUSTOM_SERVICES = 'custom_services',
  JOB_OWNER = 'job_owner';
